import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useUserContext } from '../../context/UserContext'; 

const OtaUpdateForm = () => {
  const [selectedDevice, setSelectedDevice] = useState(''); // Changed to single selection
  const [firmware, setFirmware] = useState({
    https_url: 'https://ota1.b-cdn.net/test_pcb_main_v13.bin',
    http_url: 'http://ota1.b-cdn.net/test_pcb_main_v13.bin',
    version: '1.4'
  });
  const [loading, setLoading] = useState(false);
  const { token } = useUserContext();
  // Dummy device data - replace with actual device list from your API
  const deviceOptions = [
    { id: '84CCA850235C', name: 'Gauge Test Device' },
    { id: 'E831CD803100', name: 'Gauge Device 2' },
    { id: 'C8F09E317B40', name: 'Gauge Device 3' },
    // { id: '84CCA850235E', name: 'Gauge Device 3' },
  ];

  const handleDeviceSelect = (e) => {
    setSelectedDevice(e.target.value);
  };

  const handleFirmwareChange = (e) => {
    const { name, value } = e.target;
    setFirmware(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedDevice) {
      toast.error('Please select a device');
      return;
    }

    setLoading(true);
    const toastId = toast.loading('Sending OTA update...');
    
    try {
      const payload = {
        devices: [{
          device_id: `gaugeTest_${selectedDevice}`,
          ...firmware
        }]
      };

      
      const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/devices/ota`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to send OTA update');
      }
      
      const result = await response.json();
      toast.success('OTA update initiated successfully!', { id: toastId });
      console.log('OTA Update Result:', result);
    } catch (error) {
      console.error('Error sending OTA update:', error);
      toast.error(error.message || 'Failed to send OTA update. Please try again.', { id: toastId });
    } finally {
      setLoading(false);
    }
  };

  const inputStyles = {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '8px',
    border: '2px solid #e3f2fd',
    fontSize: '14px',
    transition: 'all 0.3s ease',
    backgroundColor: '#fafafa',
    outline: 'none',
    boxSizing: 'border-box',
    marginBottom: '16px'
  };

  const selectStyles = {
    ...inputStyles,
    cursor: 'pointer'
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f5f9ff', 
      paddingTop: '80px',
      paddingBottom: '40px'
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '0 20px'
      }}>
        {/* Header */}
        <div style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          padding: '32px',
          marginBottom: '32px',
          boxShadow: '0 4px 20px rgba(33, 150, 243, 0.1)',
          border: '1px solid #e3f2fd'
        }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#1565c0',
            margin: '0 0 8px 0',
            textAlign: 'center'
          }}>
            OTA Firmware Update
          </h1>
          <p style={{
            fontSize: '16px',
            color: '#64b5f6',
            margin: '0',
            textAlign: 'center'
          }}>
            Update firmware on multiple devices
          </p>
        </div>

        {/* Main Form */}
        <div style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          padding: '32px',
          boxShadow: '0 4px 20px rgba(33, 150, 243, 0.1)',
          border: '1px solid #e3f2fd',
          marginBottom: '32px'
        }}>
          <form onSubmit={handleSubmit}>

          <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1565c0',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e3f2fd'
            }}>
              Select Device
            </h2>

            <div style={{ marginBottom: '32px' }}>
              <select
                value={selectedDevice}
                onChange={handleDeviceSelect}
                style={selectStyles}
                required
              >
                <option value="">Select a device</option>
                {deviceOptions.map(device => (
                  <option key={device.id} value={device.id}>
                    {device.name} (ID: {device.id})
                  </option>
                ))}
              </select>
            </div>
            <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1565c0',
              marginTop: '0',
              marginBottom: '24px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e3f2fd'
            }}>
              Firmware Details
            </h2>

            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '16px',
                fontWeight: '600',
                color: '#1565c0'
              }}>
                HTTPS URL
              </label>
              <input
                type="url"
                name="https_url"
                value={firmware.https_url}
                onChange={handleFirmwareChange}
                style={inputStyles}
                required
              />

              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '16px',
                fontWeight: '600',
                color: '#1565c0',
                marginTop: '16px'
              }}>
                HTTP URL
              </label>
              <input
                type="url"
                name="http_url"
                value={firmware.http_url}
                onChange={handleFirmwareChange}
                style={inputStyles}
                required
              />

              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '16px',
                fontWeight: '600',
                color: '#1565c0',
                marginTop: '16px'
              }}>
                Version
              </label>
              <input
                type="text"
                name="version"
                value={firmware.version}
                onChange={handleFirmwareChange}
                style={inputStyles}
                required
              />
            </div>

            

            <div style={{ textAlign: 'center' }}>
              <button
                type="submit"
                disabled={loading || !selectedDevice}
                style={{
                  padding: '16px 48px',
                  backgroundColor: loading || !selectedDevice ? '#90caf9' : '#2196f3',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: loading || !selectedDevice ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  boxShadow: loading || !selectedDevice ? 'none' : '0 4px 12px rgba(33, 150, 243, 0.3)',
                  minWidth: '200px',
                  opacity: loading || !selectedDevice ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!loading && selectedDevice) {
                    e.target.style.backgroundColor = '#1976d2';
                    e.target.style.boxShadow = '0 6px 16px rgba(33, 150, 243, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading && selectedDevice) {
                    e.target.style.backgroundColor = '#2196f3';
                    e.target.style.boxShadow = '0 4px 12px rgba(33, 150, 243, 0.3)';
                  }
                }}
              >
                {loading ? (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{
                      width: '20px',
                      height: '20px',
                      border: '2px solid #fff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginRight: '8px'
                    }}></div>
                    Updating...
                  </div>
                ) : (
                  `Update Device`
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <style>{
        `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `
      }</style>
    </div>
  );
};

export default OtaUpdateForm;